/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { IntlService } from 'ember-intl';
import type { Link, LinkManagerService } from 'ember-link';
import type {
  Notification,
  NotificationType,
} from 'walden-fast/types/notification';
import type { User } from 'walden-fast/types/user';
import { t } from 'walden-fast/utils/intl';
import type { ImpersonationAccount } from 'walden-fast/types/fast-backend/account';

export interface NavbarSignature {
  Args: {
    availableLanguages: string[];
    availableAccounts: ImpersonationAccount[];
    changeLanguage: (language: string) => void;
    language: string;
    logout: (event: MouseEvent) => void;
    notifications: Notification[];
    notificationsEnabled: boolean;
    user: User;
  };
  Element: HTMLElement;
}

export default class NavbarComponent extends Component<NavbarSignature> {
  @service('intl') declare intl: IntlService;
  @service('link-manager') declare linkManager: LinkManagerService;

  titleTranslation = (type: NotificationType) => {
    const keyMap: Record<NotificationType, string> = {
      'customer-service': t(
        'components.navbar.notifications.type.customerService',
      ),
      'walden-view': t('components.navbar.notifications.type.waldenView'),
      'walden-ml': t('components.navbar.notifications.type.waldenMl'),
    };
    return this.intl.t(keyMap[type]);
  };

  link = (type: NotificationType) => {
    const keyMap: Record<NotificationType, Link | undefined> = {
      'customer-service': this.linkManager.createLink({ route: 'app.contact' }),
      'walden-view': undefined,
      'walden-ml': undefined,
    };
    return keyMap[type];
  };
}
